export default "__VITE_ASSET__zsY0pu9L__"